/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Why_Everywhere_TitleInputs */

const en_wc_why_everywhere_title = /** @type {(inputs: Wc_Why_Everywhere_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Runs everywhere`)
};

/**
* | output |
* | --- |
* | "Runs everywhere" |
*
* @param {Wc_Why_Everywhere_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_why_everywhere_title = /** @type {((inputs?: Wc_Why_Everywhere_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Why_Everywhere_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_why_everywhere_title(inputs)
});
export { wc_why_everywhere_title as "wc.why.everywhere.title" }